import { css } from 'lit';
import { hostReset, floatingPanel, placementOrigins } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  floatingPanel('.panel', { durationVar: '--uwc-popover-duration', durationDefault: '160ms' }),
  placementOrigins,
  css`
    :host { display: contents; }
    slot[name="trigger"] { display: contents; }

    /* ── Panel (visual) ─────────────────────────────────────────────────────── */
    .panel {
      background:    var(--uwc-popover-bg,        ${t.surface});
      border:        var(--uwc-popover-border,     1px solid ${t.border});
      border-radius: var(--uwc-popover-radius,     ${t.radiusLg});
      box-shadow:    var(--uwc-popover-shadow,     ${t.shadowLg});
      min-width:     var(--uwc-popover-min-width,  180px);
      z-index:       var(--uwc-popover-z,          ${t.zFloat});
      overflow:      hidden;
    }

    /* ── Arrow ──────────────────────────────────────────────────────────────── */
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background: var(--uwc-popover-bg,     ${t.surface});
      border:     var(--uwc-popover-border, 1px solid ${t.border});
      transform: rotate(45deg);
      border-radius: ${t.radiusXs};
      z-index: -1;
    }

    /* ── Header ─────────────────────────────────────────────────────────────── */
    .header {
      display: flex;
      align-items: center;
      gap: ${t.space2};
      padding: ${t.space3} ${t.space4};
      border-bottom: 1px solid var(--uwc-popover-separator-color, ${t.borderSubtle});
      background: var(--uwc-popover-header-bg, transparent);
    }
    .header-content { flex: 1; min-width: 0; }
    .header-text {
      font-size:   ${t.fontSizeSm};
      font-weight: ${t.fontWeightSemibold};
      color:       var(--uwc-popover-header-color, ${t.text});
    }

    /* ── Close button ───────────────────────────────────────────────────────── */
    .close-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border: none;
      border-radius: var(--uwc-radius-sm, ${t.radiusSm});
      background: transparent;
      font-size: ${t.fontSizeXs};
      color: ${t.textMuted};
      cursor: pointer;
      flex-shrink: 0;
      transition: background ${t.durationFast}, color ${t.durationFast};
    }
    .close-btn:hover { background: var(--uwc-hover-bg, ${t.hoverBg}); color: ${t.text}; }

    /* ── Body & footer ──────────────────────────────────────────────────────── */
    .body { padding: 0; }
    .footer { padding: 10px ${t.space4}; border-top: 1px solid var(--uwc-popover-separator-color, ${t.borderSubtle}); }
  `,
];
